import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    defaultMessage: "There’s a problem with app.",
    description: "title",
    id: "WnlZMO",
  },
  content: {
    defaultMessage:
      "Saleor couldn’t fetch crucial information regarding installation. Without those System can’t install the app in your Saleor. Please use the button below to get back to system’s dashboard.",
    description: "content",
    id: "4yRwN+",
  },
  backButton: {
    defaultMessage: "Back to homepage",
    description: "button",
    id: "906uUr",
  },
});
